import { ReactElement } from 'react';
import { IFragmentPhoneNumber } from 'types/contentful';

interface ContactNumberProps {
  numbers?: IFragmentPhoneNumber[];
}

export default function PhoneIconButton({ numbers }: ContactNumberProps): ReactElement | null {
  const phone = numbers?.[0];

  if (!phone) return null;

  const icon = (
    <img src="/images/Phone-2.svg" alt="phone icon" width={56} height={56} className="mx-auto" />
  );

  return (
    <div className="flex justify-center items-center">
      <div className="inline-block">
        {phone.fields.type === 'Phone' ? (
          <a href={`tel:${phone.fields.number}`} rel="noreferrer">
            {icon}
          </a>
        ) : (
          icon
        )}
      </div>
    </div>
  );
}
